import { Mail, Phone } from 'lucide-react';

const Section = ({ title, children }) => (
  <section className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 md:p-8">
    <h2 className="font-heading text-2xl font-bold text-[#122A5C] mb-4">{title}</h2>
    <div className="space-y-3 text-slate-700 leading-relaxed">{children}</div>
  </section>
);

export const Impressum = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-20 md:py-28" data-testid="impressum-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10">
          <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-[#E07000] mb-4">
            Rechtliches
          </span>
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-[#122A5C]">
            Impressum
          </h1>
        </div>

        <div className="space-y-6">
          <Section title="Angaben gemäß § 5 DDG">
            <p className="font-semibold text-[#122A5C]">Kirsten und Klein eGbR Roofshare Solutions</p>
            <p>mit Sitz in Quedlinburg</p>
            <p>handelnd unter der Bezeichnung EN:POWER</p>
            <p>
              Geschäftsanschrift:<br />
              Haferfeld 3<br />
              06485 Quedlinburg<br />
              Deutschland
            </p>
            <p>
              – eingetragen im Gesellschaftsregister des Amtsgerichts Stendal unter GsR 1464 –
            </p>
          </Section>

          <Section title="Vertreten durch die vertretungsberechtigten Gesellschafter">
            <p>Randy Wesley Kirsten</p>
            <p>Lee-Ann Sophie Klein</p>
          </Section>

          <Section title="Kontakt">
            <div className="space-y-3">
              <a href="tel:+491608732681" className="flex items-center gap-3 text-slate-700 hover:text-[#E07000] transition-colors">
                <Phone className="w-5 h-5 text-[#E07000]" />
                Telefon: +49 160 8732681
              </a>
              <a href="mailto:info@en-power.eu" className="flex items-center gap-3 text-slate-700 hover:text-[#E07000] transition-colors">
                <Mail className="w-5 h-5 text-[#E07000]" />
                E-Mail: info@en-power.eu
              </a>
            </div>
          </Section>

          <Section title="Redaktionell verantwortlich nach § 18 Abs. 2 MStV">
            <p>
              Randy Wesley Kirsten<br />
              Haferfeld 3<br />
              06485 Quedlinburg<br />
              Deutschland
            </p>
          </Section>

          <Section title="Verbraucherstreitbeilegung / Verbraucherschlichtungsstelle">
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </Section>
        </div>
      </div>
    </div>
  );
};
